module.exports = __webpack_public_path__ + "static/img/326_TO8_2513_og.cbe792c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/326_TO8_2513_og.jpg
// module id = GrTO
// module chunks = 0